import { Box } from '@mui/material';
import React from 'react'
import CustomMobileInput from './CustomMobileInput';
import { useTranslation } from 'react-i18next';
import ButtonComponent from './ButtonComponent';
import { CustomTextInput } from './CustomTextInput';

export const CustomSwitchInput = ({ isMobile = false, mobile, email, handleSetMobile, toggleInput, handleSetEmail, validation,error,disabled,hasSwitchedAuthMethod,enableTabs}) => {
    const { t } = useTranslation()
    
    return (
        <div className="inputContainer">
            {isMobile ?
                <CustomMobileInput
                    handleSetMobile={handleSetMobile}
                    autoFocus={true}
                    value={mobile}
                    handleKeyDown={validation}
                    hasError={error}
                /> :
                <CustomTextInput
                    className="emailInput"
                    autoFocus={true}
                    placeholder={t('enterEmailAddress')}
                    type='email'
                    onChange={handleSetEmail}
                    value={email}
                    handleKeyDown={validation}
                    hasError={error}
                />
                }
        </div>
    )
}
